import quickFetch from 'quick-fetch';
import { createChirpAvroRpcClientV1 } from 'rpc-client-utils';
import PortalIdParser from 'PortalIdParser';
import { getAppName, getAppVersion } from './app';
const getSearchParams = () => {
  const init = {};
  const portalId = PortalIdParser.get();
  if (portalId) {
    init.portalId = portalId.toString();
  }
  const hsStaticApp = getAppName();
  if (hsStaticApp) {
    init.hs_static_app = hsStaticApp;
  }
  const hsStaticAppVersion = getAppVersion();
  if (hsStaticAppVersion) {
    init.hs_static_app_version = hsStaticAppVersion;
  }
  return new URLSearchParams(init);
};
const getCsrfToken = () => {
  var _parts$1$split$;
  const value = `; ${document.cookie}`;
  const parts = value.split('; csrf.app=');
  return parts.length >= 2 ? (_parts$1$split$ = parts[1].split(';')[0]) !== null && _parts$1$split$ !== void 0 ? _parts$1$split$ : null : null;
};
const keepaliveFetch = (input, init) => {
  const csrfToken = getCsrfToken();
  let url = quickFetch.getApiUrl(typeof input === 'string' ? input : input instanceof URL ? input.href : input.url);
  const searchParams = getSearchParams();
  if (searchParams.size > 0) {
    url = url.includes('?') ? `${url}&${searchParams}` : `${url}?${searchParams}`;
  }
  return fetch(url, Object.assign({}, init, {
    keepalive: true,
    credentials: 'include',
    headers: Object.assign({}, init === null || init === void 0 ? void 0 : init.headers, csrfToken && {
      'X-HubSpot-CSRF-hubspotapi': csrfToken
    })
  }));
};
export const keepAliveChirpClient = createChirpAvroRpcClientV1({
  fetchClient: keepaliveFetch
});